import axios from "axios";
import { toDate } from "date-fns/esm";

export const LOGIN_URL = `${process.env.REACT_APP_API_URL}user/login`;
export const REGISTER_URL = `${process.env.REACT_APP_API_URL}user/registration`;
export const REQUEST_PASSWORD_URL = `${process.env.REACT_APP_API_URL}user/registration`;

export const ME_URL = "api/admin/get-user-by-token?token=";

export function register(patientid, firstname, lastname, email, phone, dob, password) {
  const formData = new FormData();
  formData.append('PatientId', patientid);
  formData.append('FirstName', firstname);
  formData.append('LastName', lastname);
  formData.append('Email', email);
  formData.append('Phone', phone);
  formData.append('DateofBirth', dob);
  formData.append('Password', password);
  const options = {
    headers: { 'content-type': 'multipart/form-data'}
  };
  return axios.post(REGISTER_URL, formData, options);
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getAuthToken() {
  // Authorization head should be fulfilled in interceptor.
  // console.log("====>", JSON.parse(localStorage.getItem("persist:userData")));
  const parsedJson =  JSON.parse(localStorage.getItem("persist:userData"));
  // if (parsedJson) {
  //   console.log(parsedJson);
  //   console.log(parsedJson.authToken);
  //   console.log('ini');
  // }
   return parsedJson.authToken;
  // return axios.get(ME_URL `${}`);
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  const parsedJson =  JSON.parse(localStorage.getItem("persist:userData"));
  return parsedJson && parsedJson.user?parsedJson.user:'';
}
export function getPersist() {
  // Authorization head should be fulfilled in interceptor.
  const parsedJson =  JSON.parse(localStorage.getItem("persist:userData"));
  return parsedJson._persist;
}

export function IsReferralAdmin() {
  var loggedinUserdata = JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user);
  if(loggedinUserdata.roleName.toLowerCase() == "referral-admin" || loggedinUserdata.roleName.toLowerCase() == "referral admin"){
    return true;
  }
  return false;
}

export function checkModulePermission(moduleName) {
  var loggedinUserdata = JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user);
  let  parsedJson =  JSON.parse(localStorage.getItem("persist:userData")).modulelist;
  if(parsedJson && typeof parsedJson =='string')
    parsedJson =  JSON.parse(parsedJson);

  // console.log("moduleName", moduleName, parsedJson.findIndex(el=>el.moduleName === 'list-users-limited'));
  if(loggedinUserdata.roleName == "super-admin"){
    if(parsedJson){
      let index = parsedJson.findIndex(el=>el.moduleName === 'list-users-limited')
      if(index !== -1 &&  moduleName =='list-users'){
        return true;
      }
      else if(index !== -1 && parsedJson.findIndex(el=>el.moduleName === 'add-user') !== -1 && moduleName =='add-user'){
        return true;
      }
      else if(index !== -1 && parsedJson.findIndex(el=>el.moduleName === 'edit-user') !== -1 && moduleName =='edit-user'){
        return true;
      }
      else if(index !== -1 && moduleName == 'list-users-limited'){
        return true;
      }
      else if(index == -1 && moduleName !== 'list-users-limited'){
        return true;
      }
    }
    return false;
  }

  //Check module/action permission.
  // const parsedJson =  JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).modulelist);
  if(parsedJson && parsedJson.length > 0 ) {
    return parsedJson.some(function (el) {
      return el.moduleName === moduleName;
    });
  }else {
    return false
  }

  return parsedJson._persist;
}
